<template>
  <v-icon :color="color">
    {{ icon }}
  </v-icon>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    }
  },
  computed: {
    isActive() {
      return this.status === 'Active';
    },
    isDraft() {
      return this.status === 'Draft';
    },
    isInactive() {
      return ['Inactive', 'Locked'].includes(this.status);
    },
    isLocked() {
      return this.status === 'Locked';
    },
    color() {
      if (this.isActive) {
        return 'success';
      } else if (this.isDraft) {
        return 'warning';
      } else if (this.isInactive) {
        return 'error';
      }
      return '';
    },
    icon() {
      if (this.isActive) {
        //return 'fal fa-spin fa-spinner';
        return 'fal fa-check-circle';
      } else if (this.isDraft) {
        return 'fal fa-spin fa-spinner';
      }
      return 'fal fa-circle';
    }
  }
}
</script>
